import { Fragment, useState } from "react";
import {
    PointsCount,
    PowerupEllipse,
    PowerupsDropdown,
} from "../../../set/components";
import { CustomModal } from "../../../shared/components";
import useSound from "use-sound";
import { analytics } from "@services/analytics";
import { useRouter } from "next/router";

interface collectionHeaderProps {
    type?: "app" | "content";
    student?: any;
    totalQuestions: number;
    timer: number;
    duration: number;
    handlePowerupClick: any;
    content: any;
    questionNumber: number;
    questionStep: number;
    totalQuestionSteps: number;
    questionOnly: number;
    points: number;
    decreasePoints: boolean;
    baseAnalyticsEvent: any;
    totalPoints: number;
    scoreType?: "points" | "stars" | string;
    fillerType?: "background" | "strip";
    index?: string;
}

export const zeroPad = (num, places) => String(num).padStart(places, "0");

export const CollectionHeader: React.FC<collectionHeaderProps> = ({
    type = "content",
    student,
    totalQuestions,
    timer,
    duration,
    handlePowerupClick,
    content,
    questionNumber,
    questionStep,
    totalQuestionSteps,
    questionOnly,
    baseAnalyticsEvent,
    totalPoints,
    scoreType = "points",
    fillerType = "background",
    index = "",
    collection,
    set,
}) => {
    const [playPowerupMenuSound] = useSound(
        "/assets/sounds/Open Menu_bubble-pop-swoosh-SBA-300463464.mp3",
    );
    const [playPowerupSelectSound] = useSound(
        "/assets/sounds/Select Sound_minimal-beep-alert-2-SBA-300463242.mp3",
    );
    const [showDropdown, setShowDropdown] = useState(false);
    // const [totalPoints, setTotalPoints] = useState(student.points);

    const { query } = useRouter();
    const { collection_id, set_id } = query;
    const isContentQuestion = () =>
        content.type == "question" || content.type == "re_order";
    const powerupEllipseClick = async ({ method = "arrow_button" }) => {
        let content_type = "";
        if (isContentQuestion()) {
            if (questionStep < 1) content_type = "question_screen";
            else if (questionStep == 1) content_type = "points_screen";
            else if (questionStep == 2) content_type = "gift_screen";
            else if (questionStep == 3) content_type = "meme_screen";
            else if (questionStep == 4) content_type = "score_screen";
        } else content_type = "learn_screen";
        await analytics.track(
            !showDropdown ? "powerups_menu_opened" : "powerups_menu_closed",
            {
                referrer: content_type,
                method,
                question_no: isContentQuestion() ? questionNumber : null,
                total_questions: isContentQuestion() ? totalQuestions : null,
                ...baseAnalyticsEvent,
            },
        );

        playPowerupMenuSound();
        setShowDropdown(!showDropdown);
    };
    return (
        <Fragment>
            {fillerType === "background" && (
                <div className="box-border fixed top-0 z-20 bg-white w-i h-14">
                    <div
                        style={{ width: `${100 - (timer / duration) * 100}%` }}
                        className={
                            "h-full" +
                            " " +
                            (type === "app"
                                ? " bg-light-cyan bg-opacity-100"
                                : "bg-cadmium-yellow bg-opacity-20") +
                            " " +
                            (timer
                                ? "transition-width duration-1000 ease-in"
                                : "")
                        }
                    ></div>
                </div>
            )}
            <div className="box-border fixed top-0 z-30 bg-transparent w-i">
                {fillerType === "strip" && (
                    <div className="h-1 w-i bg-corn-silk">
                        <div
                            style={{ width: "50%" }}
                            className={
                                "h-full rounded-l-lg  bg-gargoyle-gas opacity-100"
                            }
                        />
                    </div>
                )}
                <div className="flex flex-row items-center justify-between h-16 px-4 py-3 ">
                    <div style={questionOnly ? { transform: "scale(0)" } : {}}>
                        <PowerupEllipse
                            onClick={powerupEllipseClick}
                            showDropdown={showDropdown}
                            powerupCount={
                                student?.powerups?.reduce(function (acc, obj) {
                                    return acc + obj.count;
                                }, 0) || 0
                            }
                        />
                    </div>

                    {set.type == "practise_learn_practise" ? (
                        <div className="p-2 my-2 text-base font-bold rounded-md text-dark-purple bg-light-cyan">
                            {set.type == "practise_learn_practise"
                                ? "Level " + collection.other.level
                                : collection.title}
                        </div>
                    ) : index ? (
                        <div className="p-2 my-2 text-base font-bold rounded-md text-dark-purple bg-light-cyan">
                            {index}
                        </div>
                    ) : isContentQuestion() &&
                      questionStep < totalQuestionSteps ? (
                        <div className="p-2 my-2 text-base font-bold rounded-md text-dark-purple bg-light-cyan">
                            {questionStep <= 0
                                ? questionNumber
                                : questionNumber - 1}
                            /{totalQuestions}
                        </div>
                    ) : (
                        ""
                    )}

                    <div style={questionOnly ? { transform: "scale(0)" } : {}}>
                        <PointsCount
                            points={zeroPad(totalPoints, 3)}
                            scoreType={scoreType}
                        />
                    </div>
                </div>
            </div>
            {showDropdown && (
                <CustomModal callback={powerupEllipseClick} top={"52px"}>
                    <PowerupsDropdown
                        powerups={student.powerups}
                        onPowerupClick={async (props: any) => {
                            const { type } = props;
                            let questionScreen = "question_screen";
                            switch (questionStep) {
                                case 0:
                                    questionScreen = "question_screen";
                                    break;
                                case 1:
                                    questionScreen =
                                        collection.type ==
                                        "practise_learn_practise"
                                            ? "star_screen"
                                            : "points_screen";
                                    break;
                                case 2:
                                    questionScreen = "gift_screen";
                                    break;
                                case 3:
                                    questionScreen = "meme_screen";
                                    break;
                                case 4:
                                    questionScreen = "score_screen";
                                    break;
                            }

                            const powerupEvent = {
                                referrer: isContentQuestion()
                                    ? questionScreen
                                    : "learn_screen",
                                question_no: isContentQuestion()
                                    ? questionNumber
                                    : null,
                                total_questions: isContentQuestion()
                                    ? totalQuestions
                                    : null,
                                ...baseAnalyticsEvent,

                                powerup_type: type,
                            };
                            playPowerupSelectSound();
                            await analytics.track(
                                "powerup_clicked",
                                powerupEvent,
                            );

                            const isPowerupApplied = await handlePowerupClick(
                                props,
                            );
                            if (isPowerupApplied)
                                await analytics.track(
                                    "powerups_applied",
                                    powerupEvent,
                                );
                            else
                                await analytics.track(
                                    "powerups_application_failed",
                                    powerupEvent,
                                );

                            setShowDropdown(false);
                        }}
                        set={set}
                    />
                </CustomModal>
            )}
        </Fragment>
    );
};
